import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// Không cần getFunctions và httpsCallable nữa

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

// URL của Cloud Functions, bạn có thể đặt vào file .env nếu muốn
export const inviteUserUrl = `https://us-central1-${process.env.REACT_APP_PROJECT_ID}.cloudfunctions.net/inviteUser`;
export const createUserDirectlyUrl = `https://us-central1-${process.env.REACT_APP_PROJECT_ID}.cloudfunctions.net/createUserDirectly`;

// Base URL cho các Cloud Functions khác
export const functionsBaseUrl = `https://us-central1-${process.env.REACT_APP_PROJECT_ID}.cloudfunctions.net`;